module.exports = __webpack_public_path__ + "img/trendiencer.89678f69.jpg";